<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content">

        <div class="box citic-box">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="正常待发布小程序" name="0" >
              <el-table :data="uncomfirmList" style="width:100%; margin-bottom: 20px;"  border >
                <el-table-column prop="createtime" label="注册时间" width="170" fixed></el-table-column>
                <el-table-column prop="factory_qc_name" label="厂商名称" width="200" fixed></el-table-column>
                <el-table-column prop="factory_short_name" label="厂商简称" width="130"></el-table-column>
                <el-table-column label="小程序二维码" width="150" prop="cs_qrcode_url">
                  <template slot-scope="scope" >
                    <el-popover
                      placement="left-start"
                      width="50px"
                      trigger="click">
                      <img :src="scope.row.cs_qrcode_url == null ? scope.row.app_qrcode : scope.row.cs_qrcode_url" alt="" width="250px">
                      <el-button slot="reference" type="primary">查看二维码</el-button>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column prop="isoriginalfactory" label="是否推荐" width="120">
                  <template slot-scope="scope">
                    <!-- <el-button @click="recommend(scope.row)" type="primary" size="small" :disabled="scope.row.isrecommend == 1 " >{{scope.row.isrecommend == 1 ? '已推荐' : '推荐'}}</el-button> -->
                    <el-button @click="recommend(scope.row)" type="primary" size="small" v-if="scope.row.emailaccount !== '' && scope.row.emailaccount !== null ">{{scope.row.isrecommend == 1 ? '取消推荐'  : '推荐'}}</el-button>
                    <el-button @click="recommend(scope.row)" type="primary" size="small" v-else-if="scope.row.emailaccount == '' || scope.row.emailaccount == null " :disabled="scope.row.emailaccount == '' || scope.row.emailaccount == null ">无法推荐</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="accountquality_status" label="账号质量" width="120"  >
                  <template slot-scope="scope">
                    <!-- <el-tag type="success">{{scope.row.accountquality_status}}</el-tag> -->
                    <el-select v-model="scope.row.accountquality_status" placeholder="请选择" size="mini" @change="handlequality(scope.row)">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="newsnum" label="发布新闻数" width="110"></el-table-column>
                <el-table-column prop="casenum" label="发布案例数" width="110"></el-table-column>
                <el-table-column prop="productnum" label="发布产品数" width="110"></el-table-column>
                <el-table-column prop="productimagenum" label="产品图片数" width="110"></el-table-column>
                <el-table-column prop="isoriginalfactory" label="是否已推广" width="120">
                  <template slot-scope="scope">
                    <el-button @click="extension(scope.row)" type="primary" size="small" v-if="scope.row.emailaccount !== '' && scope.row.emailaccount !== null " :disabled="scope.row.isextension === '1'">{{scope.row.isextension === '1' ? '已推广'  : '推广'}}</el-button>
                    <el-button @click="extension(scope.row)" type="primary" size="small" v-else-if="scope.row.emailaccount == '' || scope.row.emailaccount == null " :disabled="scope.row.emailaccount == '' || scope.row.emailaccount == null ">无法推广</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="extensiontime" label="推广日期" width="160">
                  <template slot-scope="scope">
                    <span v-if="scope.row.isextension === '1' ">{{scope.row.extensiontime}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="emailaccount" label="管理员手机号" width="150"></el-table-column>
                <!-- 新增 -->
                <el-table-column prop="isExamine" label="是否提交微信审核" width="170"></el-table-column>
                <el-table-column prop="isExamineSuccess" label="微信审核是否通过" width="200"></el-table-column>
                <el-table-column prop="isPulish" label="是否发布小程序" width="130">
                  <!-- <template slot-scope="scope">
                    <span>{{ scope.row.isPulish}}</span>
                  </template> -->
                </el-table-column>
                <el-table-column prop="isendemail" label="邮件通知" width="280">
                  <template slot-scope="scope">
                    <el-button @click="send(scope.row)" type="warning" size="small" v-if="scope.row.isExamineSuccess === '否'">微信审核尚未通过，暂不支持发送邮件</el-button>
                    <el-button @click="send(scope.row)" type="primary" size="small" v-else-if="scope.row.isExamineSuccess === '是'">发送邮件</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="isendemail" label="邮件历史" width="150">
                  <template slot-scope="scope">
                    <el-button @click="changeStatus(scope.row)" type="info" size="small" v-if=" scope.row.isendemail === '是' ">已发邮件</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="app_nick_name"  label="小程序名称" width="150"></el-table-column>
                 <!-- <el-button type="text" @click="centerDialogVisible = true">查看二维码</el-button>
                 <el-dialog
                   title="小程序二维码"
                   :visible.sync="centerDialogVisible"
                   width="25%"
                   center>
                   <img :src="scope.row.app_qrcode == null ? 'https://xuanxingbao.com/etc/newhome/images/code.jpg' : scope.row.app_qrcode" alt="">
                   <span slot="footer" class="dialog-footer">
                     <el-button @click="centerDialogVisible = false">取 消</el-button>
                   </span>
                 </el-dialog> -->
                <!-- <el-table-column prop="isZf" label="是否购买套餐" width="130">
                </el-table-column> -->
                <el-table-column prop="isoriginalfactory" label="是否原厂" width="120">
                  <template slot-scope="scope">
                    <el-button @click="confirm(scope.row)" type="primary" size="small" :disabled="scope.row.isoriginalfactory !== '否'" >{{scope.row.isoriginalfactory == "否" ? '待认证' : '已认证'}}</el-button>
                    <!-- <el-button type="primary" size="small" :disabled="scope.row.isExamineSuccess === '否' ? false : true" >确认</el-button> -->
                  </template>
                </el-table-column>
                
              </el-table>
            <!-- 分页 -->
          <div class="table-list__footer">
            <el-pagination
              @current-change="handlePageChangeOne"
              :current-page="currentPage.one"
              :page-size="page_size"
              layout="total, prev, pager, next, jumper"
              :total="totalOne">
            </el-pagination>
          </div>
           </el-tab-pane>
            <el-tab-pane label="正常已发布小程序" name="1" >
              <el-table :data="comfirmList" style="width:100%; margin-bottom: 20px;"  border >
                <el-table-column prop="createtime" label="注册时间" width="170" fixed></el-table-column>
                <el-table-column prop="factory_qc_name" label="厂商名称" width="200" fixed></el-table-column>
                <el-table-column prop="factory_short_name" label="厂商简称" width="130"></el-table-column>
                <el-table-column label="小程序二维码" width="150" prop="cs_qrcode_url">
                  <template slot-scope="scope" >
                    <el-popover
                      placement="left-start"
                      width="50px"
                      trigger="click">
                      <img :src="scope.row.cs_qrcode_url == null ? scope.row.app_qrcode : scope.row.cs_qrcode_url" alt="" width="250px">
                      <el-button slot="reference" type="primary">查看二维码</el-button>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column prop="isoriginalfactory" label="是否推荐" width="120">
                  <template slot-scope="scope">
                    <!-- <el-button @click="recommend(scope.row)" type="primary" size="small" :disabled="scope.row.isrecommend == 1 " >{{scope.row.isrecommend == 1 ? '已推荐' : '推荐'}}</el-button> -->
                    <el-button @click="recommend(scope.row)" type="primary" size="small">{{scope.row.isrecommend == 1 ? '取消推荐' : '推荐'}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="accountquality_status" label="账号质量" width="120"  >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.accountquality_status" placeholder="请选择" size="mini" @change="handlequality(scope.row)">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="newsnum" label="发布新闻数" width="110"></el-table-column>
                <el-table-column prop="casenum" label="发布案例数" width="110"></el-table-column>
                <el-table-column prop="productnum" label="发布产品数" width="110"></el-table-column>
                <el-table-column prop="productimagenum" label="产品图片数" width="110"></el-table-column>
                <el-table-column prop="isoriginalfactory" label="是否已推广" width="120">
                  <template slot-scope="scope">
                    <!-- <el-button @click="recommend(scope.row)" type="primary" size="small" :disabled="scope.row.isrecommend == 1 " >{{scope.row.isrecommend == 1 ? '已推荐' : '推荐'}}</el-button> -->
                    <el-button @click="extension(scope.row)" type="primary" size="small" v-if="scope.row.emailaccount !== '' && scope.row.emailaccount !== null " :disabled="scope.row.isextension === '1'">{{scope.row.isextension === '1' ? '已推广'  : '推广'}}</el-button>
                    <el-button @click="extension(scope.row)" type="primary" size="small" v-else-if="scope.row.emailaccount == '' || scope.row.emailaccount == null " :disabled="scope.row.emailaccount == '' || scope.row.emailaccount == null ">无法推广</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="extensiontime" label="推广日期" width="160">
                  <template slot-scope="scope">
                    <span v-if="scope.row.isextension === '1' ">{{scope.row.extensiontime}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="nickname" label="管理员姓名" width="110"></el-table-column>
                <el-table-column prop="emailaccount" label="管理员手机号" width="150"></el-table-column>
                <el-table-column prop="now_template_id" label="当前版本" width="110"></el-table-column>
                <el-table-column label="是否最新版本" width="110">
                  <template slot-scope="scope">
                    <p v-if="parseInt(scope.row.now_template_id) === parseInt(scope.row.latest_version)">是</p>
                    <p v-else>否</p>
                  </template>
                </el-table-column>
                <el-table-column label="更新小程序" width="110">
                  <template slot-scope="scope">
                    <el-button type="primary" @click="handleUpdateMp(scope.row.id, scope.row)" :disabled="scope.row.disabled || scope.row.loading">{{scope.row.loading ? '提交中...' : '更新'}}</el-button>
                  </template>
                </el-table-column>
                <!-- 新增 -->
                <!-- <el-table-column prop="isExamine" label="是否提交微信审核" width="170"></el-table-column>
                <el-table-column prop="isExamineSuccess" label="微信审核是否通过" width="200"></el-table-column>
                <el-table-column prop="isPulish" label="是否发布小程序" width="130">
                </el-table-column>
                <el-table-column prop="isendemail" label="邮件通知" width="210">
                  <template slot-scope="scope">
                    <el-button @click="send(scope.row)" type="warning" size="small" v-if="scope.row.isPulish === '否'">微信审核尚未通过，暂不支持发送邮件</el-button>
                    <el-button @click="send(scope.row)" type="primary" size="small" v-else-if="scope.row.isPulish === '是'">发送邮件</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="isendemail" label="邮件历史" width="150">
                  <template slot-scope="scope">
                    <el-button @click="changeStatus(scope.row)" type="info" size="small" v-if=" scope.row.isendemail === '是' ">已发邮件</el-button>
                  </template>
                </el-table-column> -->
                <el-table-column prop="app_nick_name"  label="小程序名称"></el-table-column>
                <!-- <el-table-column prop="isZf" label="是否购买套餐" width="130">
                </el-table-column> -->
                <el-table-column prop="isoriginalfactory" label="是否原厂">
                  <template slot-scope="scope">
                    <el-button @click="confirm(scope.row)" type="primary" size="small" :disabled="scope.row.isoriginalfactory !== '否'" >{{scope.row.isoriginalfactory == "否" ? '待认证' : '已认证'}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="isoriginalfactory" label="禁止跳转到选型宝小程序">
                  <template slot-scope="scope">
                    <el-button @click="jump(scope.row)" type="primary" size="small" >{{scope.row.is_jump === '1' ? '跳转' : '取消跳转'}}</el-button>
                  </template>
                </el-table-column>
                
              </el-table>
          <!-- 分页 -->
          <div class="table-list__footer">
            <el-pagination
              @current-change="handlePageChangeTwo"
              :current-page="currentPage.two"
              :page-size="page_size"
              layout="total, prev, pager, next, jumper"
              :total="totalTwo">
            </el-pagination>
          </div>
           </el-tab-pane>
            <el-tab-pane label="测试账号" name="2" >
              <el-table :data="testList" style="width:100%; margin-bottom: 20px;"  border >
                <el-table-column prop="createtime" label="注册时间" width="170" fixed></el-table-column>
                <el-table-column prop="factory_qc_name" label="厂商名称" width="200" fixed></el-table-column>
                <el-table-column prop="factory_short_name" label="厂商简称" width="130"></el-table-column>
                <el-table-column label="小程序二维码" width="150" prop="cs_qrcode_url">
                  <template slot-scope="scope" >
                    <el-popover
                      placement="left-start"
                      width="50px"
                      trigger="click">
                      <img :src="scope.row.cs_qrcode_url == null ? scope.row.app_qrcode : scope.row.cs_qrcode_url" alt="" width="250px">
                      <el-button slot="reference" type="primary">查看二维码</el-button>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column prop="isoriginalfactory" label="是否推荐" width="120">
                  <template slot-scope="scope">
                    <!-- <el-button @click="recommend(scope.row)" type="primary" size="small" :disabled="scope.row.isrecommend == 1 " >{{scope.row.isrecommend == 1 ? '已推荐' : '推荐'}}</el-button> -->
                    <el-button @click="recommend(scope.row)" type="primary" size="small">{{scope.row.isrecommend == 1 ? '取消推荐' : '推荐'}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="accountquality_status" label="账号质量" width="120"  >
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.accountquality_status" placeholder="请选择" size="mini" @change="handlequality(scope.row)">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="nickname" label="管理员姓名" width="110"></el-table-column>
                <el-table-column prop="emailaccount" label="管理员手机号" width="150"></el-table-column>
                <!-- 新增 -->
                <el-table-column prop="isExamine" label="是否提交微信审核" width="170"></el-table-column>
                <el-table-column prop="isExamineSuccess" label="微信审核是否通过" width="200"></el-table-column>
                <el-table-column prop="isPulish" label="是否发布小程序" width="130">
                </el-table-column>
                <!-- <el-table-column prop="isendemail" label="邮件通知" width="280">
                  <template slot-scope="scope">
                    <el-button @click="send(scope.row)" type="warning" size="small" v-if="scope.row.isPulish === '否'">尚未生成小程序，暂不支持发送邮件</el-button>
                    <el-button @click="send(scope.row)" type="primary" size="small" v-else-if="scope.row.isPulish === '是'">发送邮件</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="isendemail" label="邮件历史" width="150">
                  <template slot-scope="scope">
                    <el-button @click="changeStatus(scope.row)" type="info" size="small" v-if=" scope.row.isendemail === '是' ">已发邮件</el-button>
                  </template>
                </el-table-column> -->
                <el-table-column prop="app_nick_name"  label="小程序名称" width="150"></el-table-column>
                <!-- <el-table-column prop="isZf" label="是否购买套餐" width="130">
                </el-table-column> -->
                <el-table-column prop="isoriginalfactory" label="是否原厂" width="120">
                  <template slot-scope="scope">
                    <el-button @click="confirm(scope.row)" type="primary" size="small" :disabled="scope.row.isoriginalfactory !== '否'" >{{scope.row.isoriginalfactory == "否" ? '待认证' : '已认证'}}</el-button>
                  </template>
                </el-table-column>
                
              </el-table>
          <!-- 分页 -->
          <div class="table-list__footer">
            <el-pagination
              @current-change="handlePageChangeThree"
              :current-page="currentPage.three"
              :page-size="page_size"
              layout="total, prev, pager, next, jumper"
              :total="totalThree">
            </el-pagination>
          </div>
           </el-tab-pane>
            <el-tab-pane label="垃圾账号" name="3" >
              <el-table :data="rubblishList" style="width:100%; margin-bottom: 20px;"  border >
                <el-table-column prop="createtime" label="注册时间" width="170" fixed></el-table-column>
                <el-table-column prop="factory_qc_name" label="厂商名称" width="200" fixed></el-table-column>
                <el-table-column prop="factory_short_name" label="厂商简称" width="130"></el-table-column>
                <el-table-column label="小程序二维码" width="150" prop="cs_qrcode_url">
                  <template slot-scope="scope" >
                    <el-popover
                      placement="left-start"
                      width="50px"
                      trigger="click">
                      <img :src="scope.row.cs_qrcode_url == null ? scope.row.app_qrcode : scope.row.cs_qrcode_url" alt="" width="250px">
                      <el-button slot="reference" type="primary">查看二维码</el-button>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column prop="isoriginalfactory" label="是否推荐" width="120">
                  <template slot-scope="scope">
                    <!-- <el-button @click="recommend(scope.row)" type="primary" size="small" :disabled="scope.row.isrecommend == 1 " >{{scope.row.isrecommend == 1 ? '已推荐' : '推荐'}}</el-button> -->
                    <el-button @click="recommend(scope.row)" type="primary" size="small">{{scope.row.isrecommend == 1 ? '取消推荐' : '推荐'}}</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="accountquality_status" label="账号质量" width="120">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.accountquality_status" placeholder="请选择" size="mini" @change="handlequality(scope.row)">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="nickname" label="管理员姓名" width="110"></el-table-column>
                <el-table-column prop="emailaccount" label="管理员手机号" width="150"></el-table-column>
                <!-- 新增 -->
                <el-table-column prop="isExamine" label="是否提交微信审核" width="170"></el-table-column>
                <el-table-column prop="isExamineSuccess" label="微信审核是否通过" width="200"></el-table-column>
                <el-table-column prop="isPulish" label="是否发布小程序" width="130">
                </el-table-column>
                <!-- <el-table-column prop="isendemail" label="邮件通知" width="280">
                  <template slot-scope="scope">
                    <el-button @click="send(scope.row)" type="warning" size="small" v-if="scope.row.isPulish === '否'">尚未生成小程序，暂不支持发送邮件</el-button>
                    <el-button @click="send(scope.row)" type="primary" size="small" v-else-if="scope.row.isPulish === '是'">发送邮件</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="isendemail" label="邮件历史" width="150">
                  <template slot-scope="scope">
                    <el-button @click="changeStatus(scope.row)" type="info" size="small" v-if=" scope.row.isendemail === '是' ">已发邮件</el-button>
                  </template>
                </el-table-column> -->
                <el-table-column prop="app_nick_name"  label="小程序名称" width="150"></el-table-column>
                <!-- <el-table-column prop="isZf" label="是否购买套餐" width="130">
                </el-table-column> -->
                <el-table-column prop="isoriginalfactory" label="是否原厂" width="120">
                  <template slot-scope="scope">
                    <el-button @click="confirm(scope.row)" type="primary" size="small" :disabled="scope.row.isoriginalfactory !== '否'" >{{scope.row.isoriginalfactory == "否" ? '待认证' : '已认证'}}</el-button>
                  </template>
                </el-table-column>
                
              </el-table>
          <!-- 分页 -->
          <div class="table-list__footer">
            <el-pagination
              @current-change="handlePageChangeFour"
              :current-page="currentPage.four"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="totalFour">
            </el-pagination>
          </div>
           </el-tab-pane>
           
          </el-tabs>
        </div>
        
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import ThePageHeader from '../../partials/ThePageHeader'
import TheSlideBox from '../../partials/TheSlideBox'
import TheSearchBox from '../../widgets/widgetSearchBox'
import {setCookie, getCookie} from 'src/lib/utils'
export default {
  name: 'PostHome',
  components: {
    ThePageHeader,
    TheSlideBox,
    TheSearchBox
  },
  data () {
    return {
      currentPage: {
        one: 0,
        two: 0,
        three: 0,
        four: 0
      },
      totalOne: 0,
      totalTwo: 0,
      totalThree: 0,
      totalFour: 0,
      value: '',
      options: [
        {value: 1,
          label: '正常账号'
        },
        {value: 2,
          label: '测试账号'
        },
        {value: 3,
          label: '垃圾账号'
        }
      ],
      uncomfirmList: [],
      comfirmList: [],
      testList: [],
      rubblishList: [],
      activeName: '0',
      // currentPage: 1,
      pageSize: 10,
      total: 0,
      enterprise_account_id: 1,
      loading: false,
      centerDialogVisible: false,
      isDisabled: false
    }
  },
  methods: {
    // 已发布小程序禁止跳转选型宝小程序
    jump (scope) {
      let url = this.$config.API.enterprise.jump
      let data = {
        enterprise_account_id: scope.id,
        is_jump: scope.is_jump === '1' ? '0' : '1'
      }
      axios.post(url, data).then(res => {
        this.fetchData(this.activeName)
        this.$message.success('跳转修改成功')
      })
    },
    // 是否推广
    extension (scope) {
      let url = this.$config.API.enterprise.extension
      let data = {
        enterprise_account_id: scope.id,
        isextension: scope.isextension === '1' ? '0' : '1'
      }
      axios.post(url, data
      ).then(res => {
        this.fetchData(this.activeName)
        this.$message.success('修改成功')
      })
    },
    // tab切换
    handleClick (tab, event) {
      console.log('activeName', this.activeName)
      // this.currentPage = 1
      this.fetchData(this.activeName)
      console.log('tab', event)
    },
    // 确认原厂状态
    confirm (scope) {
      let url = this.$config.API.enterprise.company
      let data = {
        enterprise_account_id: scope.id
      }
      axios.post(url, data
      ).then(res => {
        // this.$set(this.comfirmList, index, {isoriginalfactory: !this.comfirmList.isoriginalfactory})
        // console.log('修改', this.comfirmList.isoriginalfactory)
        // this.fetchData('0')
        // this.fetchData('1')
        // this.fetchData('2')
        // this.fetchData('3')
        this.fetchData(this.activeName)
        this.$message.success('修改成功')
      })
      // this.isDisabled = true
    },
    // 修改推荐成功
    recommend (scope) {
      let url = this.$config.API.enterprise.recommend
      let data = {
        enterprise_account_id: scope.id,
        isrecommend: scope.isrecommend === '1' ? '0' : '1'
      }
      axios.post(url, data
      ).then(res => {
        // this.fetchData('0')
        // this.fetchData('1')
        // this.fetchData('2')
        // this.fetchData('3')
        this.fetchData(this.activeName)
        this.$message.success('修改成功')
      })
    },
    // 修改账户质量
    handlequality (scope) {
      console.log(scope)
      let url = this.$config.API.enterprise.quality
      let data = {
        enterprise_account_id: scope.id,
        accountquality_status: scope.accountquality_status
      }
      // this.accountquality_status = scope.row.accountquality_status
      // this.scope.row.accountquality_status = scope
      axios.post(url, data
      ).then(res => {
        // this.fetchData('0')
        // this.fetchData('1')
        // this.fetchData('2')
        // this.fetchData('3')
        this.fetchData(this.activeName)
        // this.uncomfirmList.forEach(item => {
        //   item.accountquality_status = this.options.value
        // })
        this.$message.success('修改成功')
      })
    },
    // 当点击邮件通知发送邮件
    send (scope) {
      // window.open('https://exmail.qq.com/')
      console.log('send')
      let url = this.$config.API.enterprise.status
      let data = {
        enterprise_account_id: scope.id
      }
      // let formData = new FormData()
      // formData.append('enterprise_account_id', this.enterprise_account_id)
      axios.post(url, data
        // headers: {
        //   'Content-Type': 'application/x-www-form-urlencoded'
        // }
      ).then(res => {
        // this.fetchData('0')
        // this.fetchData('1')
        // this.fetchData('2')
        // this.fetchData('3')
        this.fetchData(this.activeName)
        this.$message.success('邮件发送成功！')
      }).catch(() => {
        this.$message.error('邮件发送失败，请联系管理员')
      })
    },
    // 获取列表数据
    fetchData (activeName) {
      let url = this.$config.API.enterprise.account
      this.loading = true
      const pageObj = {
        '0': this.currentPage.one,
        '1': this.currentPage.two,
        '2': this.currentPage.three,
        '3': this.currentPage.four
      }
      // 1、2是activeName 一一对应
      axios.get(url, {
        params: {
          page: Number(pageObj[this.activeName]),
          enterprise_account_id: this.enterprise_account_id,
          // type: Number(this.activeName) === 0 ? 0 : Number(this.activeName) === 2 || 3 ? null : 1,
          type: Number(this.activeName) === 2 ? null : (Number(this.activeName) === 3 ? null : Number(this.activeName)),
          // type: Number(this.activeName) === (2 || 3) ? null : Number(this.activeName),
          accountquality_status: Number(this.activeName) === 0 ? 1 : Number(this.activeName)
        }
      }).then(res => {
        if (activeName === '0') {
          this.uncomfirmList = res.data.data.enterpriseaccountList
          this.uncomfirmList.forEach(item => {
            item.accountquality_status = item.accountquality_status === '2' ? '测试账号' : (item.accountquality_status === '3' ? '垃圾账号' : '正常账号')
          })
          this.totalOne = res.data.TOTAL_NUM
          this.loading = false
          console.log('1', this.uncomfirmList)
        } else if (activeName === '1') {
          let list = res.data.data.enterpriseaccountList.map(item => {
            if (parseInt(item.now_template_id) === parseInt(item.latest_version)) {
              item.disabled = true
            } else {
              if (getCookie(item.id)) {
                item.disabled = true
              } else {
                item.disabled = false
              }
            }
            item.loading = false
            return item
          })
          this.comfirmList = list
          this.comfirmList.forEach(item => {
            item.accountquality_status = item.accountquality_status === '2' ? '测试账号' : (item.accountquality_status === '3' ? '垃圾账号' : '正常账号')
          })
          this.totalTwo = res.data.TOTAL_NUM
          this.loading = false
          console.log('1', this.comfirmList)
        } else if (activeName === '2') {
          this.testList = res.data.data.enterpriseaccountList
          this.testList.forEach(item => {
            item.accountquality_status = item.accountquality_status === '2' ? '测试账号' : (item.accountquality_status === '3' ? '垃圾账号' : '正常账号')
          })
          this.totalThree = res.data.TOTAL_NUM
          this.loading = false
          console.log('1', this.testList)
        } else {
          this.rubblishList = res.data.data.enterpriseaccountList
          this.rubblishList.forEach(item => {
            item.accountquality_status = item.accountquality_status === '2' ? '测试账号' : (item.accountquality_status === '3' ? '垃圾账号' : '正常账号')
          })
          this.totalFour = res.data.TOTAL_NUM
          this.loading = false
          console.log('1', this.rubblishList)
        }
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 页面分页
    handlePageChangeOne (page) {
      this.currentPage.one = page
      this.fetchData('0')
    },
    handlePageChangeTwo (page) {
      this.currentPage.two = page
      this.fetchData('1')
    },
    handlePageChangeThree (page) {
      this.currentPage.three = page
      this.fetchData('2')
    },
    handlePageChangeFour (page) {
      this.currentPage.four = page
      this.fetchData('3')
    },
    async handleUpdateMp (eid, item) {
      if (getCookie(eid)) return
      item.loading = true
      let data = {enterprise_account_id: eid}
      try {
        let res = await this.requests.mpUpdate(data)
        if (res.data.result === 'success') {
          this.$message.success('提交审核成功')
          item.loading = false
          item.disabled = true
          setCookie(eid, 'updated', 0.5)
        }
      } catch (err) {
        this.$message.error(err.response.data.message || '提交小程序出错')
      }
    }
  },
  // 渲染数据列表
  mounted () {
    this.fetchData('0')
    this.fetchData('1')
    this.fetchData('2')
    this.fetchData('3')
  }
}
</script>
<style lang="scss">
  .citic-box {
    padding-top: 15px;
    .el-tabs__content {
      overflow: visible !important;
      position: static;
    }
    .box-header {
      ul.nav-tabs {
        margin-bottom: 0 !important;
        border-bottom: 0;
        li > a {
          color: #9ebbcd !important;
        }
        li.active > a {
          color: #333 !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// enterprise.vue?63414c4e